
import request from '@/utils/httpRequest'

export default class contractAdjustService {
    getContractInfo(contractId) {
        return request({
            url: '/mater/contract/viewContract',
            method: 'get',
            params: {
                contractId: contractId
            },
            class:'mater'
        })
    }
}
